import { useAppSelector } from "@/redux/store.ts";

export default function SubFamilyName() {
    const subFamilyName = useAppSelector((state) => state.subFamily.name);

    if (!subFamilyName) return null;

    return <h1 className="h2 sub-family-name">{subFamilyName}</h1>;
}
